import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  parsing: {
    xAxisKey: 'date',
    yAxisKey: 'num'
  },
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  stacked: false,
  plugins: {
    plugin1: false,
    plugin2: false,
    datalabels: false,
    legend: {
      display: false,
      labels: {
        filter: (legendItem) => {
          // 레전드 항목에 대한 조건을 지정하고 해당하는 폰트 색상을 지정
          if (legendItem.datasetIndex === 0) {
            legendItem.fontColor = "#2996E9";
            return legendItem;
          } 
          if (legendItem.datasetIndex === 1) {
            legendItem.fontColor = "#F98436";
            return legendItem;
          }
          return null;
        },
        usePointerStyle: true
      }
    },
    tooltip: {
      displayColors: false,
      backgroundColor: 'white', 
      bodyFont: {
        weight: 'bold',
        size: 16
      }, 
      callbacks: {
        title: ()=>{
          return ""
        },
        label: (context) => {
          return context.formattedValue;
        },
        labelTextColor: (context) => {
          return context.datasetIndex ? '#F98436' : '#2996E9';
        },
      }
    }
  },
  scales: {
    x: {
      display: true,
      grid: {
        display: false,
      },
      border: {
        display: false
      },
      ticks: {
        color: 'rgba(116,138,161,0.7)',
      }
    },
    y: {
      display: false,
    },
    y1: {
      display: false,
    },
  },
  elements: {
    line: {
      tension: 0.4
    }
  }
};


function PatientDetailDiaryLineChart({cravingData, drinkingData}) {
  const [chartData, setChartData] = useState({});

  useEffect(()=>{
    const data = {
      datasets: [
        {
          label: '갈망정도',
          data: cravingData,
          borderColor: '#2996E9',
          backgroundColor: '#2996E9',
          yAxisID: 'y',
          borderWidth: 1,
          pointStyle: 'circle',
          pointRadius: 2,
          pointBorderColor: '#2996E9',
          pointBorderWidth: 2,
          pointBackgroundColor: '#fff',
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: '#fff'
        },
        {
          label: '음주량 (잔)',
          data: drinkingData,
          borderColor: '#F98436',
          backgroundColor: '#F98436',
          yAxisID: 'y1',
          borderWidth: 1,
          pointStyle: 'circle',
          pointRadius: 2,
          pointBorderColor: '#F98436',
          pointBorderWidth: 2,
          pointBackgroundColor: '#fff',
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: '#fff'
        },
      ],
    };

    setChartData({...data});
  },[cravingData, drinkingData])

  return Object.keys(chartData).length && <Line options={options} data={chartData} />;
}

export default PatientDetailDiaryLineChart;